import React, { useCallback } from 'react';
import { GroupToRole } from '../views/PrivilegedGroupsEditView';
import { useModalContext } from '../../../components/organisms/ModalDialog/ModalContext';
import { useDelayed } from '../../../hooks/useDelayed';
import { Form, SubmitButton, useForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import FormMultiselectContainer from '../../../components/molecules/Form/components/FormMultiselect/FormMultiselect';
import { FormMultiselectModifier } from '../../../components/molecules/Form/components/FormMultiselect/FormMultiselect';

type PrivilegedGroupsEditFormProps = {
  groupToRole?: GroupToRole;
  refreshView: () => void;
};

export function PrivilegedGroupsEditForm({ groupToRole, refreshView }: PrivilegedGroupsEditFormProps) {
  const { t } = useSonTranslation('PrivilegedGroups');

  const { closeModal } = useModalContext();
  const refreshAndClose = useCallback(() => {
    refreshView();
    closeModal();
  }, [closeModal, refreshView]);
  const delayedRefreshAndClose = useDelayed(refreshAndClose);
  const onSuccess = () => {
    delayedRefreshAndClose();
  };

  const { formProps, params, fetchState } = useForm({
    form: groupToRole!.edit,
    onSuccess,
  });

  const groupIdParam = params.getByName('groupId');
  const grantedRolesParam = params.getByName('grantedRoles');

  if (!groupToRole) {
    return;
  }

  return (
    <Form id="privileged-groups-edit-form" {...formProps}>
      <div className="privileged-groups__roles-selection">
        <div className="privileged-groups__roles-selection-column">
          <p className="privileged-groups__roles-selection-group">
            <dfn className="privileged-groups__roles-selection-dfn">{t('group')}: </dfn>
            <span className="privileged-groups__roles-selection-group-name">{groupToRole.groupName}</span>
          </p>
        </div>
        {groupIdParam && grantedRolesParam && (
          <div className="privileged-groups__roles-selection-column">
            <FormMultiselectContainer
              name="grantedRoles"
              title={t('glossary:role_plural')}
              items={grantedRolesParam.options}
              modifier={FormMultiselectModifier.WIDTH_100}
            />
            <input type="hidden" name="groupId" value={groupToRole.groupId} />
          </div>
        )}
      </div>
      <SubmitButton
        buttonLabel={t('editGroupsAndRoles')}
        messageSuccess={t('phrases.edit.success')}
        messageSending={t('phrases.edit.sending')}
        messageFail={t('phrases.edit.fail')}
        fetchState={fetchState}
        customErrorTypeMessages={{
          missingButRequired: t('phrases.edit.missingButRequired'),
        }}
      />
    </Form>
  );
}
